





















import { getGrabTodoList } from '@/api/todo';
import { grabTodoListInstance } from '@/model/GrabTodoListClass';
import { releaseTodoListInstance } from '@/model/ReleaseTodoListClass';
import { AccountModule } from '@/store/modules/account';
import { Component, Vue } from 'vue-property-decorator';
import GrabTodoList from './grabTodoList.vue';
import ReleaseTodoList from './releaseTodoList.vue';

type IGrabTodoInfo = ITodo.IResponse.IGrabTodoInfo;


@Component({
  name: 'GrabTodo',
  components: {
    GrabTodoList,
    ReleaseTodoList,
  },
})
export default class GrabTodo extends Vue {
  private tabActiveKey: 'grab' | 'release' = 'grab';
  private grabTodoListInstance = grabTodoListInstance;
  private releaseTodoListInstance = releaseTodoListInstance;
  private spinning = false;
  private grabTodoActiveKey = '';
  private releaseTodoActiveKey = '';
  get grabTodoList() {
    return this.grabTodoListInstance.list;
  }
  get releaseTodoList() {
    return this.releaseTodoListInstance.list;
  }
  get isHasPermission() {
    const permissionNames = AccountModule.permissions.map((item) => item.name);
    const permissionValue: string[] = ['Todo_CreateUpdate'];
    const hasPermission = permissionValue.some((name) => {
      return permissionNames.includes(name);
    });
    return hasPermission;
  }
  private created() {
    const {id, tabKey} = this.$route.params;
    if (tabKey) {
      this.tabActiveKey = tabKey as 'grab' | 'release';
    }
    if (tabKey === 'grab' && id) {
      this.grabTodoActiveKey = id;
    }
    if (tabKey === 'release' && id) {
      this.releaseTodoActiveKey = id;
    }
  }
  private getGrabTodos() {
    this.spinning = true;
    this.grabTodoListInstance.requestGrabTodoList().catch((err) => {
      this.$message.warning(err);
    }).finally(() => {
      this.spinning = false;
    });
  }
  private getReleaseTodos() {
    this.spinning = true;
    this.releaseTodoListInstance.requestGrabTodoList().catch((err) => {
      this.$message.warning(err);
    }).finally(() => {
      this.spinning = false;
    });
  }
}
